export default __webpack_public_path__ + "static/media/left-leafs.0cd9b005.svg";